"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTranslationSchema = void 0;
const zod_1 = require("zod");
exports.CustomTranslationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    known_txt: zod_1.z.string(),
    learn_txt: zod_1.z.string(),
});
//# sourceMappingURL=custom_translation_types.js.map